import Link from "@/components/common/DashboardLink";
import {
  BsArrowRight,
  BsBank2,
  BsBullseye,
  BsLightningChargeFill,
} from "react-icons/bs";

const LOG_ROWS = [
  {
    id: 1,
    name: "Acme Corp",
    method: "ACH",
    address: "0x7a2f…9c4e",
    usd: "+$4,200",
    crypto: "→ 0.0612 ETH",
    time: "2 min ago",
  },
  {
    id: 2,
    name: "Northwind LLC",
    method: "WIRE",
    address: "0x3b91…e8a1",
    usd: "+$12,800",
    crypto: "→ 0.186 ETH",
    time: "18 min ago",
  },
  {
    id: 3,
    name: "Globex Trading",
    method: "ACH",
    address: "0x9d44…2f00",
    usd: "+$2,150",
    crypto: "→ 0.0314 ETH",
    time: "1 hr ago",
  },
  {
    id: 4,
    name: "Stark Industries",
    method: "WIRE",
    address: "0x1c88…7bba",
    usd: "+$8,400",
    crypto: "→ 0.122 ETH",
    time: "Yesterday",
  },
];

function MiniFlow() {
  return (
    <div className="fp-log-row__flow" aria-hidden>
      <span className="fp-mini-icon">
        <BsBank2 />
      </span>
      <span className="fp-log-row__flow-arrow">→</span>
      <span className="fp-mini-icon">
        <BsLightningChargeFill />
      </span>
      <span className="fp-log-row__flow-arrow">→</span>
      <span className="fp-mini-icon">
        <BsBullseye />
      </span>
    </div>
  );
}

const FlowPayDashboardCenter = () => {
  return (
    <div className="flowpay-dashboard">
      <div className="fp-bank-card">
        <div className="fp-bank-card__top">
          <div>
            <div className="fp-bank-card__status-row">
              <span className="fp-bank-card__dot" />
              <span className="fp-bank-card__status-label">
                US Virtual Bank — Active
              </span>
            </div>
            <p className="fp-bank-card__meta mb-0">
              Routing <strong className="text-white fw-semibold">0260XXXX</strong>
              <br />
              Account <strong className="text-white fw-semibold">•••• 8821</strong>
            </p>
          </div>
          <div className="fp-bank-card__balance-block">
            <div className="fp-bank-card__balance-label">USD Balance</div>
            <div className="fp-bank-card__balance-amt">$0.00</div>
            <div className="fp-bank-card__balance-caption">
              Funds pass through instantly.
            </div>
          </div>
        </div>

        <div className="fp-bank-card__flow">
          <div className="fp-flow-steps">
            <div className="fp-flow-step">
              <div className="fp-flow-step__icon">
                <BsBank2 />
              </div>
              <div className="fp-flow-step__text">
                <span className="fp-flow-step__title">USD Arrives</span>
                <span className="fp-flow-step__sub">ACH / Wire</span>
              </div>
            </div>
            <span className="fp-flow-arrow">→</span>
            <div className="fp-flow-step">
              <div className="fp-flow-step__icon">
                <BsLightningChargeFill />
              </div>
              <div className="fp-flow-step__text">
                <span className="fp-flow-step__title">Convert</span>
                <span className="fp-flow-step__sub">Instant swap</span>
              </div>
            </div>
            <span className="fp-flow-arrow">→</span>
            <div className="fp-flow-step">
              <div className="fp-flow-step__icon">
                <BsBullseye />
              </div>
              <div className="fp-flow-step__text">
                <span className="fp-flow-step__title">Send Crypto</span>
                <span className="fp-flow-step__sub">To your wallet</span>
              </div>
            </div>
          </div>
          <div className="fp-hold-badge">
            Auto Convert Fiat to desired cryptocurrency
          </div>
        </div>
      </div>

      <div className="fp-stats">
        <div className="fp-stat-card">
          <div className="fp-stat-card__head">
            <span className="fp-stat-card__label">Received This Month</span>
            <span className="fp-stat-card__icon">
              <BsBank2 />
            </span>
          </div>
          <div className="fp-stat-card__value">$27,550</div>
          <div className="fp-stat-card__sub">6 payments</div>
        </div>
        <div className="fp-stat-card">
          <div className="fp-stat-card__head">
            <span className="fp-stat-card__label">Converted &amp; Sent</span>
            <span className="fp-stat-card__icon">
              <BsLightningChargeFill />
            </span>
          </div>
          <div className="fp-stat-card__value">$27,550</div>
          <div className="fp-stat-card__sub">100% pass-through</div>
        </div>
        <div className="fp-stat-card">
          <div className="fp-stat-card__head">
            <span className="fp-stat-card__label">Crypto Dispatched</span>
            <span className="fp-stat-card__icon">
              <BsBullseye />
            </span>
          </div>
          <div className="fp-stat-card__value">0.4007 ETH</div>
          <div className="fp-stat-card__sub">To your wallet</div>
        </div>
      </div>

      <div className="fp-log">
        <div className="fp-log__header">
          <h2 className="fp-log__title">Conversion &amp; Dispatch Log</h2>
          <Link href="/transactions" className="fp-log__view">
            View all <BsArrowRight style={{ fontSize: 16 }} />
          </Link>
        </div>
        <ul className="fp-log__list">
          {LOG_ROWS.map((row) => (
            <li key={row.id} className="fp-log-row">
              <MiniFlow />
              <div className="fp-log-row__main">
                <div className="fp-log-row__name">{row.name}</div>
                <div className="fp-log-row__meta">
                  <span className="fp-pill-ach">{row.method}</span>
                  <span className="fp-log-row__addr">{row.address}</span>
                </div>
              </div>
              <div className="fp-log-row__amounts">
                <div className="fp-log-row__usd">{row.usd}</div>
                <div className="fp-log-row__crypto">{row.crypto}</div>
                <div className="fp-log-row__time">{row.time}</div>
              </div>
              <span className="fp-badge-sent">SENT ✓</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FlowPayDashboardCenter;
